// Simple store for error page message (without API calls)
// This allows passing error message between pages without using URL params

let errorMessage: string | null = null;

export const errorStore = {
    setMessage: (message: string) => {
        errorMessage = message;
    },
    getMessage: () => {
        const message = errorMessage;
        // Clear after reading (one-time use)
        errorMessage = null;
        return message;
    },
    hasMessage: () => {
        return errorMessage !== null;
    },
};
